export default "__VITE_ASSET__6e59d779__"